import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';
import jobIssueAdditionalInfoFactory, { IJobIssueAdditionalInfo } from './jobIssueAdditionalInfoModel';
import jobIssueMaterialItemFactory, { IJobIssueMaterialItem } from './jobIssueMaterialItemModel';
import { IModelSet } from 'Scripts/modelSet';
import statusLogged, { IStatusLogged } from './statusLogged';
import additionalInfoContainer, { IAdditionalInfoContainer } from './additionalInfoContainer';

export enum JobIssueStatus {
	received = 'received',
	processing = 'processing',
	rejected = 'rejected',
	scheduled = 'scheduled',
	complete = 'complete',
	incomplete = 'incomplete'
}

export interface IJobIssue extends IModel, IStatusLogged, IAdditionalInfoContainer<IJobIssueAdditionalInfo> {
	jobCostKey?: string;
	changeOrderKey?: string;
	scheduledVisitKey?: string;
	sourceVisitKey?: string;
	workAreaKey?: string;
	sourceIssueKey?: string;
	issueNumber?: number;
	materialItems?: IModelSet<IJobIssueMaterialItem>;
	source?: string;
	issue?: string;
	description: string;
	estimatedMinutes?: number;
	deficiencyCode?: string;
	resolver?: string;
}

const JobIssueFactory = modelFactory.createFactory<IJobIssue>('JobIssue', _.assign({}, model, statusLogged(JobIssueStatus.received), additionalInfoContainer, {
	jobCostKey: {
		setFilters: valueFilters.toString,
	},
	changeOrderKey: {
		setFilters: valueFilters.toString,
	},
	scheduledVisitKey: {
		setFilters: valueFilters.toString,
	},
	sourceVisitKey: {
		setFilters: valueFilters.toString,
	},
	workAreaKey: {
		setFilters: valueFilters.toString,
	},
	sourceIssueKey: {
		setFilters: valueFilters.toString,
	},
	issueNumber: {
		setFilters: valueFilters.toNumber
	}, 
	additionalInfo: {
		defaultValue: [],
		setFilters: valueFilters.toModelSet(jobIssueAdditionalInfoFactory),
		rules: validator.validModel(jobIssueAdditionalInfoFactory.rules())
	}, 
	materialItems: {
		setFilters: valueFilters.toModelSet(jobIssueMaterialItemFactory),
		rules: validator.validModel(jobIssueMaterialItemFactory.rules())
	},
	source: {
		nonSerialized: true,
		setFilters: valueFilters.toString
	},
	_get_source: function () {
		return this.getAdditionalInfoValue('source');
	},
	_set_source: function (val) {
		this.setAdditionalInfo('source', val);
	},
	issue: {
		nonSerialized: true,
		setFilters: valueFilters.toString
	},
	_get_issue: function () {
		return this.getAdditionalInfoValue('issue');
	},
	_set_issue: function (val) {
		this.setAdditionalInfo('issue', val);
	},
	description: {
		nonSerialized: true,
		setFilters: valueFilters.toString
	},
	_get_description: function () {
		return this.getAdditionalInfoValue('description');
	},
	_set_description: function (val) {
		this.setAdditionalInfo('description', val);
	},
	estimatedMinutes: {
		nonSerialized: true,
		setFilters: valueFilters.toNumber
	},
	_get_estimatedMinutes: function () {
		const stringVal = this.getAdditionalInfoValue('estimatedMinutes');
		return stringVal && Number(stringVal);
	},
	_set_estimatedMinutes: function (val) {
		this.setAdditionalInfo('estimatedMinutes', val || undefined);
	},
	deficiencyCode: {
		nonSerialized: true,
		setFilters: valueFilters.toString
	},
	_get_deficiencyCode: function () {
		return this.getAdditionalInfoValue('deficiencyCode');
	},
	_set_deficiencyCode: function (val) {
		this.setAdditionalInfo('deficiencyCode', val);
	},
	resolver: {
		nonSerialized: true,
		setFilters: valueFilters.toString
	},
	_get_resolver: function () {
		return this.getAdditionalInfoValue('resolver');
	},
	_set_resolver: function (val) {
		this.setAdditionalInfo('resolver', val);
	},
}));

export default JobIssueFactory;